import {
  Button,
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
  Table,
} from "react-bootstrap";
import { FloatInput, HeadPage } from "src/componentes";
import NFCeCode from "./NFCe.Code";
import { NFCeModalItemConsulta } from "./Modal.Item/NFCe.Modal.Item.Consulta";
import "./Styles.css";
import { NFCeModalFinalizarView } from "./Modal.Finaliza/NFCe.Modal.Finaliza.View";
import { NFCeModalItemPropriedadesView } from "./Modal.Item/NFCe.Modal.Item.Propriedades.View";

const NFCeView = () => {
  const code = NFCeCode();

  return (
    <>
      <Container className="container-nfce">
        <Form
          noValidate
          onSubmit={code.formProdutoConsulta.handleSubmit(
            code.onSubmitProdutoConsulta
          )}
        >
          <HeadPage headText="NFCe" onToggle={code.menu.handleMenuToggleClick}>
            {code.menu.menuItens !== undefined &&
              code.menu.menuItens.map((item) => (
                <Dropdown.Item
                  key={item.nome}
                  onClick={code.menu.handleMenuClick(item)}
                >
                  {item.nome}
                </Dropdown.Item>
              ))}
          </HeadPage>
          {!code.loading && !code.configuracoes.loading ? (
            <>
              <Row>
                <Col xs={12}>
                  <FloatInput
                    label="Consulta"
                    errorsMessage={
                      code.formProdutoConsulta.formState.errors.nome
                    }
                    registerField={code.formProdutoConsulta.register("nome")}
                    textAlign="center"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="text-center">
                  <h1>{code.descricaoProdutoConsulta}</h1>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  {code.nfceCodeLoad.dataProdutoNFCe &&
                    code.nfceCodeLoad.dataProdutoNFCe.length > 0 && (
                      <Table responsive hover>
                        <thead>
                          <tr>
                            <th className="col-xs-10 col-md-8">Nome</th>
                            <th className="col-02">Qtd</th>
                            <th className="col-2 text-end">Valor</th>
                          </tr>
                        </thead>
                        <tbody>
                          {code.nfceCodeLoad.dataProdutoNFCe?.map(
                            (item, index) => (
                              <tr
                                key={index}
                                onClick={code.handleClickPropriedades(item)}
                                style={{ cursor: "pointer" }}
                              >
                                <td className="col-xs-12 col-md-8">
                                  {item.nome} {"[" + item.codigoProduto + "]"}
                                </td>
                                <td className="col-02">
                                  {item.quantidadeComercial}
                                </td>
                                <td className="col-2 text-end">
                                  {(
                                    item.valorUnitarioComercial *
                                    item.quantidadeComercial
                                  )
                                    .toFixed(2)
                                    .replace(".", ",")}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </Table>
                    )}
                </Col>
              </Row>
            </>
          ) : (
            <Placeholder as={FloatingLabel} animation="glow">
              <Placeholder xs={12} />
            </Placeholder>
          )}
        </Form>

        {code.possuiItens() && (
          <div className="fixed-bottom">
            <Container className="text-center py-3">
              <Button
                className="w-100"
                onClick={() => {
                  code.setModalShowFinaliza(true);
                }}
              >
                Finalizar {code.totalNFCe().toFixed(2).replace(".", ",")}
              </Button>
            </Container>
          </div>
        )}
        <NFCeModalItemConsulta
          show={code.modalShowConsultaProduto}
          onHide={code.onHideModalConsultaProduto}
          onSelect={code.onSelectModalConsultaProduto}
          data={code.dataProdutoConsulta}
        />
        <NFCeModalFinalizarView
          show={code.modalShowFinaliza}
          onHide={code.onHideModalFinaliza}
          totalNFCe={code.totalNFCe()}
          dataMeioPagamento={code.dataMeioPagamento}
          onSelect={code.onSelectModalFinaliza}
          onCancel={code.onCancelModalFinaliza}
          onSubmit={code.onSubmitNFCe}
        />
      </Container>
      <NFCeModalItemPropriedadesView
        show={code.modalShowPropriedades}
        produto={code.produtoPropriedades}
        onCancel={code.onCancelModalPropriedades}
        onDelete={code.onDeleteModalPropriedades}
      />
    </>
  );
};

export default NFCeView;
